import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { SidebarProvider } from './components/context/SidebarContext'
import { ThemeProvider } from './components/context/ThemeContext';

ReactDOM.render(
  <React.StrictMode>

    <SidebarProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </SidebarProvider>
    
  </React.StrictMode>,
  document.getElementById('root')
);


